import type en from "./en.json";
import i18n from "./index";

/**
 * `head` for a route: "Clientes - Soporte a Campo", translated. The Vite dev
 * server and the dev stack prefix "[Dev]" so that tab is not mistaken for
 * prod. Without a page it is just the product name. main.tsx re-runs every
 * `head` on a language change.
 */
export function pageTitle(page?: keyof typeof en) {
  const product = i18n.t("Field Support");
  const title = page ? `${i18n.t(page)} - ${product}` : product;
  // ponytail: keyed on the dev stack's domain (dev.jd.magoya.com, see
  // infra/Pulumi.dev.yaml). If it changes, expose ENVIRONMENT from the backend.
  const isDev =
    import.meta.env.DEV || window.location.hostname.startsWith("dev.");
  return { meta: [{ title: isDev ? `[Dev] ${title}` : title }] };
}
